module.exports = __webpack_public_path__ + "static/img/freeandcertification.2ae76608.png";